function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/getPrototypeOf.js
 ** module id = 15
 ** module chunks = 0
 **/